jQuery(document).ready(function($) { 

  var popup_already_display = sessionStorage.getItem('popState');
 // popup_already_display = 'test';

  if(popup_already_display != 'shown'){
    
    if ( $( ".lightbox_popup_event--link" ).length ) {
      $('.lightbox_popup_event--link').featherlight({
        otherClose : 'span.icon-close',
        loading: 'Chargement...', 
        afterOpen: function(event){
           sessionStorage.setItem('popState','shown');
           // console.log(this.lightbox); // this contains all related elements
            $('.featherlight-content').addClass('featherlight_special_event');
          }
        
      }).click();
    }
  }



   // Get the header
  var header = document.getElementById("masthead");

    // Get the offset position of the navbar
  var sticky = 36;

   function gestion_depart_stiky(largeur){
    if(largeur >= 1400){
       sticky = 36;
    }else{
      sticky = 107; // hauteur navtop + hauteur bloc logo + marge en bas
    }
  }
    function StickyScroll() {
    if ($(window).width() >= 1024){
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
   }else{
    header.classList.remove("sticky");
   }
  }


  if ( $( "#masthead" ).length  ) {

  // STICKY HEADER
    // When the user scrolls the page, execute StickyScroll 
  window.onscroll = function() {StickyScroll();};

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position


} // FIN IF EXIST #masthead


  /////////////////////////////////////
  //////// CLICK ON SEARCHTAB ////////
  var $btn_close_form = $('.js-close-form');
  var $btn_open_mobile = $('.js-mobile-open-search');
   $('li#menu-item-27 a, li#menu-item-999 a,li#menu-item-1615 a, li#menu-item-536 a, .js-mobile-open-search').on('click', function(evt) { // Au clic sur un élément
    
    $('body').toggleClass('toggle_search'); // Go
    
    if($btn_close_form.attr('aria-expanded') == 'false'){
       $btn_close_form.attr('aria-expanded','true');
    }else{
      $btn_close_form.attr('aria-expanded','false');
    }

     if($btn_open_mobile.attr('aria-expanded') == 'false'){
       $btn_open_mobile.attr('aria-expanded','true');
    }else{
      $btn_open_mobile.attr('aria-expanded','false');
    }

      evt.preventDefault();
    });


    $( ".js-close-form" ).click(function( ) {
          $(this).attr('aria-expanded','false');
          $('body').toggleClass('toggle_search'); // Go
  });



    
    var largeur_width = $(window).width();
  if ( $( "#masthead" ).length  ) {
    gestion_depart_stiky(largeur_width);
  }
    var largeur_minimum_action_mobile = 769;
    var block_title = $('.NavPlanSite-Col-Title');
    var block_footer = $('.NavPlanSite-Col > div');

     jQuery(window).resize(function () {
        largeur_width = $(window).width();
        if ( $( "#masthead" ).length  ) {
          gestion_depart_stiky(largeur_width);
        }
        gestion_block_footer();
     });
    

     function gestion_block_footer(){
        if(largeur_width < largeur_minimum_action_mobile ){
            block_footer.hide();
            block_title.removeClass('open');
        }else{
            block_footer.show();
        }
      }
       
      gestion_block_footer();

    if(largeur_width < largeur_minimum_action_mobile){
      $('.NavPlanSite-Col-Title').on('click', function() {
        $(this).toggleClass('open');
        $(this).next().slideToggle(500);
     });
    }

   

 if ( $( "#primary-menu" ).length  ) {
  /////////////////////
  /// MENU MOBILE /////

  var menu_mobile = $('#primary-menu').clone();
  
  var form_search = $(".SearchformTop-Inner").clone();
  form_search.addClass('for_menu_mobile');

  var li_boutique = $("#top-menu li:first-child").clone().addClass('SpecialBoutique');
  menu_mobile.append(li_boutique);

  var smenu_1 = $(".NavPlanSite-Col-artiste").clone().html();
  var menu_1 = '<li class="MenuParent">ARTISTES'+smenu_1+'</li>';

  var smenu_2 = $(".NavPlanSite-Col-scolaires").clone().html();
  var menu_2 = '<li class="MenuParent">Scolaires'+smenu_2+'</li>';

  var smenu_3 = $(".NavPlanSite-Col-pro").clone().html();
  var menu_3 = '<li class="MenuParent">PROFESSIONNELS & ACTEURS PUBLICS'+smenu_3+'</li>';

  var smenu_4 = $(".NavPlanSite-Col-tous").clone().html();
  var menu_4 = '<li class="MenuParent">POUR TOU.TE.S'+smenu_4+'</li>';

  var smenu_5 = $(".NavPlanSite-Col-chercheurs").clone().html();
  var menu_5 = '<li class="MenuParent">CHERCHEURS, ÉTUDIANTS'+smenu_5+'</li>';

  var ul_folow = '<li class="liSpecialFollow"><ul class="SpecialFollow">'+$(".InfoSite-FollowUs").clone().html()+'</ul></li>';

  var li_logo = '<li class="SpecialLogo">'+$(".ReturnHome").clone().html()+'</li>';


  var smenu_footer = $("#footer-menu").clone().html();
  var link_accueil_href = $(".site-branding-title a").attr('href');
  

  var link_accueil = '<li class=""><a href="'+link_accueil_href+'">Accueil</a></li>';
  menu_mobile.append(menu_1);
  menu_mobile.append(menu_2);
  menu_mobile.append(menu_3);
  menu_mobile.append(menu_4);
  menu_mobile.append(menu_5);
  menu_mobile.append(ul_folow);
  menu_mobile.append(li_logo);
  menu_mobile.append(smenu_footer);
  menu_mobile.prepend(link_accueil);
  
  
 
  // menu_mobile.append(menu_rs);
  menu_mobile.slicknav({
    duration:300,
    prependTo : "#masthead",
    beforeOpen:move_body,
    beforeClose:move_body,
    openedSymbol:">",
    closedSymbol:">"
  });

  $('.slicknav_nav').prepend(form_search);
    
}

  function move_body(){

    if($('.slicknav_btn').hasClass('slicknav_open')){
      $('body').addClass('move_to_right');
    }else{
      $('body').removeClass('move_to_right');
    }
  }




    

 //// FIN MENU MOBILE /////
 /////////////////////////
	 
   $('.SmoothScroll').on('click', function() { // Au clic sur un élément
      var page = $(this).attr('href'); // Page cible
      var speed = 450; // Durée de l'animation (en ms)
      $('html, body').animate( { scrollTop: $(page).offset().top }, speed ); // Go
      return false;
    });


  
    // ACCORDEON ///
    $('.SingleAccordeon-Content').not( "#content_s_1" ).hide();
    $('#content_acc_js_1').parent().find('h4 a').addClass('active');

   //$('.accordion-section-content').hide();
    // ACCORDEON SECTION 
    function close_accordion_section() {
        $('.SingleAccordeon-Title').removeClass('active');
        $('.SingleAccordeon-Content').slideUp(300).removeClass('open');
    }

    $('.SingleAccordeon-Title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
 
        if($(this).hasClass('active')) {
          
           // close_accordion_section();
           // $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open'); 
            $('.Accordeon ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $('.Accordeon ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //


      
  
//  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
  // WOW EFFECT //


    $('.GallerySlick').slick({
        //setting-name: setting-value
        slidesToShow:3,
        slidesToScroll: 3, 
        dots: false,
        responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            arrows:false
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
            arrows:false
          }
        },
        {
          breakpoint: 452,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows:false
          }
        }
      ]
      });

    $('.GallerySlick').slickLightbox({
        itemSelector        : 'a',
        navigateByKeyboard  : true
    });


    $('.SlideProjetsParticipatif').slick({
        //setting-name: setting-value
        slidesToShow:3,
        slidesToScroll: 3,
         dots: false,
        responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            arrows:false
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
            arrows:false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows:false
          }
        }
      ]
      });
    

    // Isotope.Item.prototype._create = function() {
    //   // assign id, used for original-order sorting
    //   this.id = this.layout.itemGUID++;
    //   // transition objects
    //   this._transn = {
    //     ingProperties: {},
    //     clean: {},
    //     onEnd: {}
    //   };
    //   this.sortData = {};
    // };

    // Isotope.Item.prototype.layoutPosition = function() {
    //   this.emitEvent( 'layout', [ this ] );
    // };

    // Isotope.prototype.arrange = function( opts ) {
    //   // set any options pass
    //   this.option( opts );
    //   this._getIsInstant();
    //   // just filter
    //   this.filteredItems = this._filter( this.items );
    //   // flag for initalized
    //   this._isLayoutInited = true;
    // };

    // // layout mode that does not position items
    // Isotope.LayoutMode.create('none');




    // ISOTOPE POUR EVT SCOLAIRE  //
    // var $grid = $('.grid').isotope({
    //     itemSelector: '.element-item',
    //     layoutMode: 'none'
    //   // options
    // });
    // // filter items on button click
    // $('.NavSecondaire-Activite-js').on( 'click', 'button', function() {
    //   var filterValue = $(this).attr('data-filter');
    //   $grid.isotope({ filter: filterValue });
    //   $('.NavSecondaire-Activite-js button').removeClass('active');
    //   $(this).addClass('active');
    // });


     $('.NavSecondaire-Activite-js').on( 'click', 'button', function() {
         var filterValue = $(this).attr('data-filter');
         if(filterValue == "*"){
          $('.element-item').slideDown(300, function(){
            //  var parent = $(this).parent();
            // setTimeout(function(){   parent.slideDown(300); }, 10);
          });
       }else{
        $( ".element-item" ).each(function( index ) {
          // if ((this).style.css('display') == 'none')

          if ($(this).hasClass(filterValue)){
              $(this).slideDown(300, function(){

                 if ($(this).parent().css('display') == 'none'){
                  // var parent = $(this).parent();
                    setTimeout(function(){   parent.slideDown(1000); }, 10);
                 }

              });
          }else{
            $(this).slideUp(300, function(){
              if (!$(this).parent().hasClass(filterValue)){
                //  var parent = $(this).parent();
                // setTimeout(function(){  parent.slideUp(1000); }, 10);
             
              }
            });
          }


      });

          }

           $('.NavSecondaire-Activite-js button').removeClass('active');
           $(this).addClass('active');

     });




    // /// ISOTOPE POUR CALENDRIER //
    // var $grid = $('.Calendar-Container--isotope--js').isotope({
    //     itemSelector: '.ItemIsotopeJs',
    //     layoutMode: 'none'
    //   // options
    // });

     // filter items on button click
    $('.NavSecondaire--Calendarjs').on( 'click', 'a', function() {
      var filterValue = $(this).attr('data-filter');
      if(filterValue == "*"){
        $('.ItemIsotopeJs').slideDown(300, function(){
           var parent = $(this).parent().parent();
          setTimeout(function(){   parent.slideDown(300); }, 10);
        });
      }
      else{
        $( ".ItemIsotopeJs" ).each(function( index ) {
          // if ((this).style.css('display') == 'none')

          if ($(this).hasClass(filterValue)){
              $(this).slideDown(300, function(){

                 if ($(this).parent().parent().css('display') == 'none'){
                  var parent = $(this).parent().parent();
                    setTimeout(function(){   parent.slideDown(300); }, 10);
                 }

              });
          }else{
            $(this).slideUp(300, function(){
              if (!$(this).parent().parent().hasClass(filterValue)){
                 var parent = $(this).parent().parent();
                setTimeout(function(){  parent.slideUp(300); }, 10);
             
              }
            });
          }


      });

          }

      
      // $grid.isotope({ filter: filterValue });
       $('.NavSecondaire--Calendarjs a').removeClass('active');
       $(this).addClass('active');

      return false;
    });






  // FORM CONTACT LABEL ///
   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea,.FormNewsletterMailChimp input" ).click(function() {
      $( this ).parent().parent().addClass('focus');
  });

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea, .FormNewsletterMailChimp input" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea, .FormNewsletterMailChimp input" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });
   

//////////////////////////////////
///////// WOOOCOMMMMERCCCEE ///////
/////////////////////////////////

   $('.products').masonry({
    // options
      itemSelector: '.product',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true, 
  });


   function init_price_filter_pm() {
      $( 'input#min_price_pm, input#max_price_pm' ).hide();
      $( '.price_slider, .price_label' ).show();

      var min_price = $( '.price_slider_amount_pm #min_price_pm' ).data( 'min' ),
        max_price = $( '.price_slider_amount_pm #max_price_pm' ).data( 'max' ),
        current_min_price = $( '.price_slider_amount_pm #min_price_pm' ).val(),
        current_max_price = $( '.price_slider_amount_pm #max_price_pm' ).val();

      $( '.price_slider:not(.ui-slider)' ).slider({
        range: true,
        animate: true,
        min: min_price,
        max: max_price,
        values: [ current_min_price, current_max_price ],
        create: function() {

          $( '.price_slider_amount_pm #min_price_pm' ).val( current_min_price );
          $( '.price_slider_amount_pm #max_price_pm' ).val( current_max_price );

          $( document.body ).trigger( 'price_slider_create_pm', [ current_min_price, current_max_price ] );
        },
        slide: function( event, ui ) {

          $( 'input#min_price_pm' ).val( ui.values[0] );
          $( 'input#max_price_pm' ).val( ui.values[1] );

          $( document.body ).trigger( 'price_slider_slide_pm', [ ui.values[0], ui.values[1] ] );
        },
        change: function( event, ui ) {

          $( document.body ).trigger( 'price_slider_change', [ ui.values[0], ui.values[1] ] );
           $(this).closest('form').trigger('submit');
        }
      });

      
      $("#dispo_artoteque").change(function() {

          $(this).closest('form').trigger('submit');

          if(this.checked) {
              $(this).next().next().html('oui');  
          }else{
              $(this).next().next().html('non'); 
          }
        //  slide_radio_arto
        
      });

    }

   if ( $( ".price_slider_wrapper--pm").length ) {


    $( document.body ).bind( 'price_slider_create_pm price_slider_slide_pm', function( event, min, max ) {

      $( '.price_slider_amount_pm span.from' ).html(min+' €');

      $( '.price_slider_amount_pm span.to' ).html(max+' €');

      $( document.body ).trigger( 'price_slider_updated', [ min, max ] );
  });

  
    init_price_filter_pm();

  }


  // OK ! On lance la lightbox avec le formulaire ! 
  $('a.link_featherlight').featherlight(
      $("#location"),
    {
    type : "html",
  });

 if ( $( "#location").length ) {

  var wpcf7Elm = document.querySelector( '.LightBoxLocation-Container .wpcf7' );
 
  wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
      
    $("#main").prepend('<div class="woocommerce-notices-wrapper"><p class="woocommerce-message">Nous avons bien pris en compte votre demande de location. <br /> <strong>Nous vous contactons dans les plus brefs délai.</strong></p></div>');

    var current = $.featherlight.current();
    current.close();

    $('html, body').animate( { scrollTop: $("main").offset().top }, 500 ); // Go


  }, false );

  }


    /////////////////////
  /// MENU MOBILE SHOP /////
  if ( $( "#shop-menu" ).length) {
   

    var menu_shop_mobile = $('#shop-menu').clone();
    
    var form_search_shop = $(".SearchformTop-Inner").clone();
    form_search_shop.addClass('for_menu_mobile');

    var li_accueil_site = $("#top-menu li:first-child").clone().addClass('SpecialBoutique');
    menu_shop_mobile.append(li_accueil_site);

    //var li_logo = '<li class="SpecialLogo">'+$(".site-branding-title").clone().html()+'</li>';

    //var link_accueil_href = $(".site-branding-title a").attr('href');

    //menu_mobile.append(li_logo);
    //menu_mobile.prepend(link_accueil);
    
    
   
    menu_shop_mobile.slicknav({
      duration:300,
      prependTo : "#masthead-shop",
      beforeOpen:move_body,
      beforeClose:move_body,
    });


    $('.slicknav_nav').prepend(form_search_shop);

  }


  //////////////////////
  /// FIN MENU MOBILE SHOP EN LIGNE ////

//////////////////////////////////
///////// FIN WOOOCOMMMMERCCCEE ///////
/////////////////////////////////



}); // fin ready menu



jQuery(window).on('load', function(){ 

   jQuery('.products').masonry({
    // options
      itemSelector: '.product',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true, 
  });

});